import {useSelector} from 'react-redux';
import {formSelector} from '../features/formSlice';

const useFormPersistedValues = formName => {
    return useSelector(formSelector(formName));
};

export default useFormPersistedValues;
